import * as React from "react"
import type { SVGProps } from "react"
const SvgRules = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M15 20.43a1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.71q0-.43.29-.71a1 1 0 0 1 .71-.29h1.6l-2.47-2.47a1 1 0 0 1-.3-.72 1 1 0 0 1 .32-.71q.3-.3.71-.3.42 0 .72.3L18 16.98v-1.55q0-.43.29-.71a1 1 0 0 1 .71-.29q.42 0 .71.29.3.29.29.71v4q0 .42-.29.71a1 1 0 0 1-.71.29zm-10.7-.3a1 1 0 0 1-.27-.7q0-.43.27-.7l12.3-12.3H15a1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.71q0-.42.29-.71a1 1 0 0 1 .71-.29h4q.42 0 .71.29.3.29.29.71v4q0 .42-.29.71a1 1 0 0 1-.71.29 1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.71v-1.6L5.7 20.13a1 1 0 0 1-.7.28 1 1 0 0 1-.7-.28m-.02-14a1 1 0 0 1-.28-.7q0-.43.28-.7a1 1 0 0 1 .68-.28q.42 0 .72.28l4.2 4.17q.27.28.28.7a1 1 0 0 1-.28.7 1 1 0 0 1-.7.28 1 1 0 0 1-.7-.28z" />
  </svg>
)
export default SvgRules
